/* Your Lovely Boutique — storefront behaviour */
(function () {
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => [...(r || document).querySelectorAll(s)];
  const money = c => {
    const n = (c / 100);
    return "$" + (Number.isInteger(n) ? n : n.toFixed(2));
  };
  const V = (window.YLB && window.YLB.videos) || {};

  /* ---------- toast ---------- */
  let tt;
  function toast(msg) {
    const el = $("#toast"); if (!el) return;
    el.textContent = msg; el.classList.add("show");
    clearTimeout(tt); tt = setTimeout(() => el.classList.remove("show"), 2200);
  }
  window.ylbToast = toast;

  /* ---------- videos: play only what's on screen ---------- */
  const vio = "IntersectionObserver" in window ? new IntersectionObserver(es => es.forEach(e => {
    const v = e.target;
    if (e.isIntersecting) { if (v.preload === "none") v.preload = "metadata"; v.play().then(() => v.classList.add("in")).catch(() => {}); }
    else v.pause();
  }), { threshold: .25 }) : null;
  const watchVideos = root => { if (vio) $$("video:not([controls])", root).forEach(v => vio.observe(v)); };
  watchVideos(document);

  /* ---------- mobile menu ---------- */
  const mb = $("#menuBtn"), mm = $("#mobileMenu");
  if (mb && mm) mb.addEventListener("click", () => { mm.hidden = !mm.hidden; });

  /* ---------- colour filter on set grids ---------- */
  $$("[data-index]").forEach(index => {
    const grid = $(`[data-grid="${index.dataset.index}"]`);
    if (!grid) return;
    index.addEventListener("click", e => {
      const b = e.target.closest("[data-f]"); if (!b) return;
      const f = b.dataset.f;
      $$("[data-f]", index).forEach(x => x.setAttribute("aria-pressed", x === b));
      let shown = 0;
      $$("[data-colour]", grid).forEach(card => {
        const on = f === "all" || card.dataset.colour === f;
        card.hidden = !on; if (on) shown++;
      });
      const count = $("[data-count]");
      if (count) count.textContent = shown + (shown === 1 ? " set" : " sets");
      const empty = $("[data-empty]", grid);
      if (empty) empty.hidden = shown !== 0;
    });
  });

  /* ---------- cart ---------- */
  const drawer = () => document.body.classList.add("open");
  const closeDrawer = () => document.body.classList.remove("open");
  $("#bagOpen") && $("#bagOpen").addEventListener("click", () => { loadCart(); drawer(); });
  $("#bagClose") && $("#bagClose").addEventListener("click", closeDrawer);
  $("#scrim") && $("#scrim").addEventListener("click", closeDrawer);
  document.addEventListener("keydown", e => { if (e.key === "Escape") { closeDrawer(); closeViewer(); } });

  function setCount(n) {
    const c = $("#bagCount"); if (!c) return;
    c.textContent = n; c.hidden = !n;
  }

  async function loadCart() {
    const lines = $("#lines"), foot = $("#df");
    if (!lines) return;
    const cart = await fetch("/cart.js").then(r => r.json());
    setCount(cart.item_count);
    if (!cart.item_count) {
      lines.innerHTML = `<p class="bag-empty">Your bag is empty.<br><a class="link" href="/collections/all" style="display:inline-block;margin-top:18px">Shop clover sets</a></p>`;
      foot.innerHTML = ""; return;
    }
    const isSet = l => /set/i.test(l.variant_title || "") || /set/i.test(l.product_title || "");
    lines.innerHTML = cart.items.map((l, i) => `<div class="line">
        <img src="${l.image ? l.image.replace(/(\.[a-z]+)(\?|$)/i, "_180x$1$2") : ""}" alt="" width="72" height="90" loading="lazy">
        <div><b>${l.product_title}</b><small>${l.variant_title && l.variant_title !== "Default Title" ? l.variant_title : ""}</small>
          <div class="qty"><button aria-label="Fewer" data-line="${i + 1}" data-qty="${l.quantity - 1}">&minus;</button><span class="num">${l.quantity}</span><button aria-label="More" data-line="${i + 1}" data-qty="${l.quantity + 1}">+</button></div>
        </div>
        <div class="r"><span class="num">${money(l.final_line_price)}</span><button class="rm" data-line="${i + 1}" data-qty="0">Remove</button></div>
      </div>`).join("")
      + (cart.items.some(isSet) ? `<div class="giftline"><img src="${window.YLB.boxImg}" alt="" width="72" height="72"><div><b>The blush gift box</b><span class="muted">Gold-foil lid, velvet insert</span></div><span class="inc">Included</span></div>` : "");
    foot.innerHTML = `<div class="tot"><span>Subtotal</span><strong class="num">${money(cart.total_price)}</strong></div>
      <div class="ship">Free US shipping &middot; taxes at checkout</div>
      <button class="btn" id="checkoutBtn">Checkout</button>`;
    $("#checkoutBtn").addEventListener("click", () => { window.location.href = "/checkout"; });
  }

  $("#lines") && $("#lines").addEventListener("click", async e => {
    const b = e.target.closest("[data-line]"); if (!b) return;
    b.disabled = true;
    const res = await fetch("/cart/change.js", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: Number(b.dataset.line), quantity: Number(b.dataset.qty) })
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      toast(err.description || "That's all we have in stock");
    }
    loadCart();
  });

  async function addToCart(id, qty) {
    const res = await fetch("/cart/add.js", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      toast(err.description || "Sorry, that one is sold out");
      return false;
    }
    await loadCart(); drawer(); return true;
  }
  window.ylbAdd = addToCart;

  document.addEventListener("click", e => {
    const a = e.target.closest("[data-add-variant]");
    if (a) { e.preventDefault(); a.blur(); addToCart(a.dataset.addVariant, 1); }
    const t = e.target.closest("[data-toast]"); if (t) toast(t.dataset.toast);
  });

  /* ---------- reviews (8 real from her TikTok Shop screenshots + samples) ---------- */
  const REAL = [
    { n: "Jessica", d: "2 Sep 2026", s: 5, p: "rv5", t: "Great quality jewelry! I've purchased a couple times and the items are always amazing." },
    { n: "Cynthia", d: "24 Aug 2026", s: 5, p: "rv2", t: "I'm not usually a pink person but this magenta one is so pretty. It's such great quality." },
    { n: "Mont RZ", d: "19 Aug 2026", s: 5, p: "rv4", t: "Amazing quality and shipping is fast, I'm obsessed with her jewelry." },
    { n: "F.", d: "11 Aug 2026", s: 5, p: "rv1", t: "Love my new clover bracelets! I don't take them off and wear them all day. Really brightens your look." },
    { n: "Cynthia", d: "3 Aug 2026", s: 5, p: "rv3", t: "I haven't seen one like this and it's so pretty and easy to stack with others from her." },
    { n: "Riyah", d: "21 Apr 2026", s: 5, p: "rv6", t: "Love her jewelry! So cute and durable!" },
    { n: "Mont RZ", d: "14 Jul 2026", s: 5, p: "rv11", t: "Great quality, I love my new bracelet." },
    { n: "Nati", d: "27 Jun 2026", s: 5, p: "rv9", t: "Absolutely love my pieces." }
  ];
  const SAMPLE = [
    { n: "Marisol G.", d: "9 Sep 2026", s: 5, p: "rv7", t: "Ordered on a Sunday and it came that Friday. The {name} looks way more expensive than it is." },
    { n: "Karla M.", d: "6 Sep 2026", s: 5, p: "rv8", t: "My skin reacts to almost everything and this hasn't bothered me once. Wore it a full week straight." },
    { n: "Brianna L.", d: "1 Sep 2026", s: 5, p: "rv10", t: "Bought it as a gift and the little pink box made it look like I spent triple. She loved it." },
    { n: "Yesenia R.", d: "28 Aug 2026", s: 5, t: "Third set from her now. The clovers are a good size, not tiny and not too big." },
    { n: "Stephanie A.", d: "22 Aug 2026", s: 4, t: "The bracelet was a bit loose on my small wrist, but the extender chain sorted it out. Still beautiful." },
    { n: "Alexa M.", d: "18 Aug 2026", s: 5, t: "Necklace sits right at the collarbone, didn't need to adjust it at all." },
    { n: "Nayeli C.", d: "12 Aug 2026", s: 5, t: "Two months of daily wear, showers included, and the gold hasn't faded." },
    { n: "Vanessa P.", d: "7 Aug 2026", s: 5, t: "Got compliments at work the first day I wore the {name}. People always ask where it's from." },
    { n: "Priscilla G.", d: "30 Jul 2026", s: 5, t: "The earrings are so light I forget I have them on." },
    { n: "Andrea S.", d: "25 Jul 2026", s: 4, t: "Took about a week to arrive, but the set is exactly like the photos. Would order again." },
    { n: "Melanie R.", d: "19 Jul 2026", s: 5, t: "Wearing the bracelet stacked with my watch every day and it still looks new." },
    { n: "Gaby O.", d: "11 Jul 2026", s: 5, t: "Packaging is so cute, it came with a little card. Ordering more for Christmas gifts." },
    { n: "Jasmine T.", d: "4 Jul 2026", s: 5, t: "Quality for the price is unmatched. I paid way more for a similar set somewhere else." },
    { n: "Daniela V.", d: "26 Jun 2026", s: 5, t: "The {name} is my everyday one now. Goes with literally everything." }
  ];
  const CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6L9 17l-5-5"/></svg>';
  const starRow = s => "★★★★★".slice(0, s) + "☆☆☆☆☆".slice(0, 5 - s);
  const hash = str => [...str].reduce((a, c) => (a * 31 + c.charCodeAt(0)) % 997, 7);

  function renderReviews(handle, title) {
    const grid = $("#rvGrid"); if (!grid) return;
    const off = hash(handle || "x");
    const pick = (arr, n, o) => Array.from({ length: n }, (_, j) => arr[(o + j) % arr.length]);
    const short = (title || "").replace(" Clover Set", "").replace("Clover Jewelry Set", "set");
    const item = (title || "").split(":")[0].replace(" Stainless Steel Jewelry Set", "").trim();
    const withPh = SAMPLE.filter(r => r.p), noPh = SAMPLE.filter(r => !r.p);
    const list = [...pick(REAL, 3, off), ...pick(withPh, 2, off), ...pick(noPh, 2, off)]
      .map(r => ({ ...r, t: r.t.replace("{name}", short), item }))
      .sort((a, b) => (b.p ? 1 : 0) - (a.p ? 1 : 0));
    const avg = (list.reduce((a, r) => a + r.s, 0) / list.length).toFixed(1);
    $("#rvAvg").textContent = avg;
    $("#rvCount").textContent = `${list.length} reviews for this set`;
    const rate = $("#pdpRate");
    if (rate) rate.innerHTML = `<span class="stars">${starRow(5)}</span> ${avg} &middot; ${list.length} reviews`;
    const RV = (window.YLB && window.YLB.rv) || {};
    const card = r => `<figure class="lx" style="margin:0">
      ${r.p && RV[r.p] ? `<div class="ph"><img src="${RV[r.p]}" alt="" width="520" height="520" loading="lazy"></div>` : ""}
      <div class="b"><div class="stars" aria-label="${r.s} out of 5">${starRow(r.s)}</div>
        <p>${r.t}</p>
        <div class="meta"><span class="nm">${r.n} ${CHECK}</span><span class="dt">${r.d}</span><span class="item">${r.item}</span></div>
      </div></figure>`;
    const first = list.slice(0, 4), rest = list.slice(4);
    grid.innerHTML = first.map(card).join("");
    const more = $("#rvMore");
    if (more) {
      more.hidden = !rest.length;
      more.textContent = `Show ${rest.length} more reviews`;
      more.addEventListener("click", () => { grid.insertAdjacentHTML("beforeend", rest.map(card).join("")); more.hidden = true; });
    }
  }

  /* ---------- product page ---------- */
  const pdp = $("#pdp");
  if (pdp) {
    const variants = JSON.parse($("#pdpVariants").textContent);
    let cur = variants.find(v => v.available) || variants[0];
    const priceEl = $("#pdpPrice"), sepEl = $("#pdpSep"), atc = $("#pdpAtc"), stickyAtc = $("#pdpStickyAtc"), payEl = $("#pdpPay"), boxEl = $("#pdpBox");
    const sep = Number(pdp.dataset.sep || 0);

    function paint() {
      priceEl.textContent = money(cur.price);
      const full = /set/i.test(cur.title) || variants.length === 1;
      sepEl.textContent = full && sep > cur.price / 100 ? `Pieces bought separately $${sep}` : (full ? "Necklace, studs and bracelet" : "Single piece");
      const label = cur.available ? `Add to bag &middot; ${money(cur.price)}` : "Sold out";
      atc.innerHTML = label; atc.disabled = !cur.available;
      if (stickyAtc) { stickyAtc.innerHTML = label; stickyAtc.disabled = !cur.available; }
      payEl.textContent = cur.price >= 5000 ? `Or 4 payments of ${money(cur.price / 4)} with Shop Pay` : "Pay with Shop Pay, PayPal or Apple Pay";
      if (boxEl) boxEl.hidden = !full;
      $$("[data-variant]").forEach(b => b.setAttribute("aria-pressed", Number(b.dataset.variant) === cur.id));
    }
    $$("[data-variant]").forEach(b => b.addEventListener("click", () => {
      cur = variants.find(v => v.id === Number(b.dataset.variant)) || cur; paint();
    }));
    [atc, stickyAtc].forEach(b => b && b.addEventListener("click", () => cur.available && addToCart(cur.id, 1)));
    paint();

    /* gallery counter */
    const gal = $("#pdpGal");
    if (gal) {
      const slides = $$(".slide", gal).length;
      const cnt = $("#pdpCount"), cap = $("#pdpCap");
      const caps = $$(".slide", gal).map(s => s.dataset.cap || "");
      if (cnt) cnt.textContent = `1 / ${slides}`;
      if (cap) cap.textContent = caps[0];
      gal.addEventListener("scroll", () => {
        const i = Math.min(slides - 1, Math.round(gal.scrollLeft / (gal.scrollWidth / slides)));
        if (cnt) cnt.textContent = `${i + 1} / ${slides}`;
        if (cap) cap.textContent = caps[i];
      });
    }

    renderReviews(pdp.dataset.handle, pdp.dataset.title);
  }

  /* ---------- clip viewer ---------- */
  const viewer = $("#viewer");
  function closeViewer() { if (!viewer) return; viewer.classList.remove("on"); const v = $("#vVideo"); if (v) v.pause(); }
  if (viewer) {
    $("#vClose").addEventListener("click", closeViewer);
    viewer.addEventListener("click", e => { if (e.target === viewer) closeViewer(); });
    document.addEventListener("click", e => {
      const c = e.target.closest("[data-clip]"); if (!c) return;
      const v = $("#vVideo");
      v.src = c.dataset.clip; v.poster = c.dataset.poster || "";
      $("#vTitle").textContent = c.dataset.title || "";
      $("#vPrice").textContent = c.dataset.price || "";
      const link = $("#vLink");
      link.href = c.dataset.url || "#"; link.textContent = "View product";
      viewer.classList.add("on"); v.play().catch(() => {});
    });
  }

  loadCart();
})();
